// extracted by mini-css-extract-plugin
export default {"tile-icon":"daily-specialsT9V7xR","tile-icon--super-offer":"daily-specialsegSbyk"};